


import XTableNamer from "./XTableNamer.js";

import * as Excel from "../../../node_modules/exceljs";
import { saveAs } from "../../../node_modules/file-saver";
import Helper from "./Helper.js";

/**
 * Exceldownload working with NSWOW2 Tables
 */
 class XDownloader {
  constructor(config = {}) {
    const {
      backgroundClass,
      backgroundClass2,
      backgroundClass2b,
      backgroundClass3,
      backgroundClass3b,
      backgroundColor, // Color
      backgroundColor2, // Color
      backgroundColor3, // Color
      boldColor,
      boldClass,
      boldClass2,
      boldClass3,
      boldClass4,
      borderClass,
      borderClass2,
      borderClass3,
      borderClass4,
      borderClass5,
      borderClass6,
      borderColor,
      borderColor2,
      borderStyle, // thin/dotted/medium/double/thick
      borderStyle2, // thin/dotted/medium/double/thick
      downloadText, // Text for downloadbutton, can be empty if you want to use an icon
      footnoteClass,
      headClass,
      headClass2,
      headClass3,
      headColor,
      superScript,
      tableName,
      indClass,
      indClass2,
      indClass3,
      highlightBorderTopClass,
      highlightBorderRightClass,
      highlightBorderBottomClass,
      highlightBorderLeftClass,
      highlightBorderColor,
      highlightBorderStyle,
      externalFootnotes,
      defaultTextColor
    } = config;

    const env = this.getEnvironement();

    this.downloadText = downloadText || 'Download Excel'; //Text on button, can be empty
    this.backgroundColor = backgroundColor || 'ecf0f1';
    this.backgroundColor2 = backgroundColor2 || '00607b';
    this.backgroundColor3 = backgroundColor3 || '009aa8';
    this.borderColor = borderColor || '34495e';
    this.borderColor2 = borderColor2 || '34495e';
    this.boldColor = boldColor || '0000FF';
    this.borderStyle = borderStyle || 'thin';
    this.borderStyle2 = borderStyle2 || 'thin';
    this.boldClass = boldClass || 'bold';
    this.boldClass2 = boldClass2 || 'bold';
    this.boldClass3 = boldClass3 || 'bold';
    this.boldClass4 = boldClass4 || 'bold';
    this.backgroundClass = backgroundClass || 'bold';
    this.backgroundClass2 = backgroundClass2 || 'bold';
    this.backgroundClass2b = backgroundClass2b || 'bold';
    this.backgroundClass3 = backgroundClass3 || 'bold';
    this.backgroundClass3b = backgroundClass3b || 'bold';
    this.borderClass = borderClass || 'border-bottom';
    this.borderClass2 = borderClass2 || 'border-bottom';
    this.borderClass3 = borderClass3 || 'border-bottom';
    this.borderClass4 = borderClass4 || 'border-bottom';
    this.borderClass5 = borderClass5 || 'border-bottom';
    this.borderClass6 = borderClass6 || 'border-bottom';
    this.footnoteClass = footnoteClass || 'footnote';
    this.headClass = headClass || 'head';
    this.headClass2 = headClass2 || 'head';
    this.headClass3 = headClass3 || 'head';
    this.headColor = headColor || 'ffffff';
    this.superScript = superScript || '()';
    this.tableName = tableName || 'download';
    this.indClass = indClass || 'ind';
    this.indClass2 = indClass2 || 'ind';
    this.indClass3 = indClass3 || 'ind';
    this.highlightBorderTopClass = highlightBorderTopClass || '';
    this.highlightBorderRightClass = highlightBorderRightClass || '';
    this.highlightBorderBottomClass = highlightBorderBottomClass || '';
    this.highlightBorderLeftClass = highlightBorderLeftClass || '';
    this.highlightBorderColor = highlightBorderColor || '0000FF';
    this.highlightBorderStyle = highlightBorderStyle || 'double';
    this.externalFootnotes = externalFootnotes || false;
    this.defaultTextColor = defaultTextColor || '000000';

    this.cellStyles = [];

    this.cellInStylesBold = null;
    this.cellInStylesLight = null;

    const tables = Array.prototype.slice.call(document.querySelectorAll('.ns-table-wrap'));

    new XTableNamer();

    tables.forEach(table => {
      if(this.checkTable(table)){
        this.addLink(table);
      } else if( env === 'stage' ){
        this.addLink(table, true);
      }
    });
  }

  checkFirstRow(table){
    let firstRow = true;
    let counter = 0

    if(!table.querySelector('tr:first-child').classList.contains('excel-download-line')) {
      table.querySelectorAll('tr:first-child > td').forEach(cell => {
        if(cell.getAttribute('colspan') > 1) {
          firstRow = false;
          counter += parseInt(cell.getAttribute('colspan'));
        } else {
          counter++;
        }

        if(cell.classList.contains('ns-tbl-head_light')){
          firstRow = false;
        }
      });

      if(!firstRow){
        let firstRowHtml = `<tr class="excel-download-line">`;
        while(counter > 0){
          firstRowHtml += `<td class="ns-tbl-head_light"></td>`;
          counter--;
        }
        firstRowHtml += `</tr>`;
        table.querySelector('tr:first-child').insertAdjacentHTML('beforebegin', firstRowHtml);
      }
    }
  }

  checkTable(table){
    const tableDatas = Array.prototype.slice.call( table.querySelectorAll('tr:first-child > td') );
    let check = true;

    tableDatas.forEach( tableData => {
      if(
        tableData.colSpan > 1 &&
        (
          !tableData.classList.contains('excel-download') ||
          !tableData.classList.contains(this.headClass)
        )
      ){
        // check = false;

        // console.log(`
        //   Die Tabelle ${table.getAttribute('data-x-file-title')} hat verbundene Zellen in der ersten Reihe, das wird nicht unterstützt vom XDownloaderow.
        //   Falls verbundene Zellen in der ersten Reihe benötigt werden bitte erste Zeile leer mit der Klasse .excel-download erfassen.
        //   Darüber hinaus muss die erste Reihe entweder die Klasse .excel-download oder .${this.headClass} haben.`
        // );
      }
    });

    return check;
  }

  addLink(table, error) {
    let link = document.createElement('a');
    link.innerText = this.downloadText;
    link.href = '#';

    error ? link.classList.add('exceldl-link', 'error') : link.classList.add('exceldl-link');

    table.prepend(link);

    link.addEventListener('click', (event) => {
      event.preventDefault();
      this.createWorkbook(table);
    });
  }

  createWorkbook(table) {
    this.checkFirstRow(table);

    let name = table.querySelector('[data-tableid]') ?
    table.querySelector('[data-tableid]').dataset.tableid :
    table.querySelector('[data-table-id]') ?
    table.querySelector('[data-table-id]').dataset.tableId :
    this.tableName;

    if(name == "download") {
      if(document.querySelector(".dlc-section__xlsdownloads")){
        name = table.parentNode.previousElementSibling.innerHTML;
      } else {
        name = this.getFileTitle(table);
      }
    }

    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(name);

    try{
      this.parseTable(table, worksheet);
      this.parseFootnote(table, worksheet);
      if(document.querySelector(".dlc-section__xlsdownloads")){
        this.saveFile(table.parentNode.previousElementSibling.innerHTML + ".xlsx", workbook);
      } else {
        if(!this.getFileTitle(table)){
          this.saveFile(document.querySelector(".ns-table-title").innerText + ".xlsx", workbook);
        } else {
          this.saveFile(this.getFileTitle(table) + ".xlsx", workbook);
        }
      }
    } catch(error){
      console.log(error);
    }
  }

  parseTable(table, worksheet) {
    const rows = Array.prototype.slice.call(table.querySelectorAll('tr'));

    let content = [];
    let mergeStrings = [];
    let row;

    let counterColumns = 0;
    let counterRows = 0;

    const title = this.getTitle(table).replace(/(\&shy;|­|&#173;)/gi, "");
    const tableTitle = this.getTableTitle(table).replace(/(\&shy;|­|&#173;)/gi, "");

    let excelDownloadLine = false;

    let styles = [];
    let first = true;

    let lines = 1;

    rows.forEach(r => {
      counterColumns = 0;
      counterRows++;
      content = [];

      const tableDatas = Array.prototype.slice.call(r.querySelectorAll('td'));

      if (r.classList.contains('excel-download-line')) {
        excelDownloadLine = true;
      }

      if(first){

        first = false;
        let tCounter = 0;

        tableDatas.forEach(t => { //first iteration for header column without content to set widths of columns
          counterColumns++;

          let width = tCounter == 0 ? 70 : t.offsetWidth / 5;
          tCounter++;

          content.push({
            header: ' ',
            key: 'id',
            width: width
          });
        });

        worksheet.columns = content;

        counterColumns = 0;
        counterRows++;
        content = [];

        row = worksheet.lastRow;
        row.height = 0.5;

        if(title){
          worksheet.addRow([]);

          if(document.documentElement.lang === "de-DE"){
            worksheet.addRow(['Vonovia SE Halbjahresbericht H1 2025']);
          } else {
            worksheet.addRow(['Vonovia SE Half-Year Report H1 2025']);
          }

          row = worksheet.lastRow;
          row.getCell('A').font = {
            size: 16,
            bold: true
          };

          worksheet.addRow([title]);

          if (tableTitle) {
            worksheet.addRow([]);
            worksheet.addRow([tableTitle]);
            row = worksheet.lastRow;
          }

        } else if (tableTitle) {
          worksheet.addRow([tableTitle]);
          row = worksheet.lastRow;

          row.getCell('A').font = {
            size: 16,
            bold: true
          };
        }

        if(!excelDownloadLine){
          worksheet.addRow([]);
        }
      }

      tableDatas.forEach(t => { //second iteration for actual content
        counterColumns++;

        styles[counterColumns] = this.getStyles(t); // get styles based on classes of the td

        let cell = this.parseCell(t, counterColumns);

        // if(this.countLines(t) > lines){
        //   lines = this.countLines(t);
        // }

        cell = isNaN(cell) ?
        cell :
        cell == '\u00A0' || cell.trim() == '' ?
        cell :
        cell = parseFloat(cell);

        content.push(cell);

        const colspan = parseInt(styles[counterColumns]['colspan']);
        if(colspan > 1){
          for (let i = 1; i < colspan; i++) {
            content.push('');
            counterColumns++;
          }
        }
      });

      worksheet.addRow(content);

      row = worksheet.lastRow;

      for (let i = 1; i < (styles.length + 1); i++) {
        if (!!styles[i]) {
          if (!!styles[i]['align']) {
            row.getCell(i).alignment = styles[i]['align'];
          }
          if (!!styles[i]['alignment']) {
            row.getCell(1).alignment = styles[i]['alignment'];
          }
          if (!!styles[i]['border']) {
            row.getCell(i).border = styles[i]['border'];
          }
          if (!!styles[i]['font']) {
            row.getCell(i).font = styles[i]['font'];
          }
          if (!!styles[i]['fill']) {
            row.getCell(i).fill = styles[i]['fill'];
          }
          if (this.cellStyles[i]) {
            row.getCell(i).border = this.cellStyles[i];
          }

          let colspan = parseInt(styles[i]['colspan']);
          let edlineFlag = table.querySelector('tr:first-child').classList.contains('excel-download-line');

          if (colspan > 1) {
            //   row.height = 15 * lines;
            let addRows = 4;
            if(tableTitle == '' && edlineFlag){
              addRows = 3;
            } else if(tableTitle != '' && !edlineFlag){
              addRows = 5;
            } else if(tableTitle != '' && edlineFlag){
              addRows = 5;
            }

            let mergeString = this.getLetter(i) + (counterRows + addRows) + ':' + this.getLetter(i + colspan - 1) + (counterRows + addRows);

            mergeStrings.forEach(el => {
              let find = el.search(this.getLetter(i) + (counterRows + addRows));
              if(find != -1){
                mergeString = this.getLetter(i + 1) + (counterRows + addRows) + ':' + this.getLetter(i + colspan - 1) + (counterRows + addRows);
              }
            });

            mergeStrings.push(mergeString);
          }
        }
      }


      // has to be build up to work with an array for more functionality ...start
      if(this.cellInStylesBold) {
        row._cells.forEach(cell => {
          if(String(cell._value.model.value).trim() == String(this.cellInStylesBold + this.cellInStylesLight)){
            worksheet.getCell(cell._address).value = {
              'richText': [
                {'font': {'bold': true, 'size' : 12, 'color': {'argb': cell.style.font.color.argb}},'text': this.cellInStylesBold},
                {'font': {'bold': false, 'size' : 12, 'color': {'argb': cell.style.font.color.argb}},'text': this.cellInStylesLight}
              ]
            };
          }
        });
      } else if(this.cellInStylesLight) {
        row._cells.forEach(cell => {
          if(String(cell._value.model.value).trim() == String(this.cellInStylesLight)){
            worksheet.getCell(cell._address).value = {
              'richText': [
                {'font': {'bold': false, 'size' : 12, 'color': {'argb': cell.style.font.color.argb}},'text': this.cellInStylesLight}
              ]
            };
          }
        });
      }
      // has to be build up to work with an array for more functionality ...end

    });

    this.mergeCells(worksheet, mergeStrings);

    lines = 1;
  }

  getStyles(t) {
    const r = [];

    r['colspan'] = t.colSpan;

    if(t.classList.contains('ns-horizontal-left')){
      r['align'] = { horizontal: 'left',  wrapText: true }
    }
    if(t.classList.contains('ns-horizontal-right')){
      r['align'] = { horizontal: 'right',  wrapText: true }
    }
    if(t.classList.contains('ns-horizontal-center')){
      r['align'] = { horizontal: 'center',  wrapText: true }
    }

    if (t.classList.contains(this.backgroundClass)) {
      r['fill'] = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF'+this.backgroundColor
        }
      };
    } else {
      r['fill'] = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          rgb: 'FFFF0000'
        }
      };
    }

    if (t.classList.contains(this.colorClass) || t.classList.contains(this.boldClass) || t.classList.contains(this.boldClass3) || t.classList.contains(this.headClass) || t.classList.contains(this.headClass3)) {
      r['font'] = {
        bold: true,
        color: {
          argb: 'FF'+this.boldColor
        },
        size: 12
      };
    } else if(t.classList.contains(this.boldClass2) || t.classList.contains(this.boldClass4) || t.classList.contains(this.headClass2)) {
      r['font'] = {
        color: {
          argb: 'FF'+this.boldColor
        },
        size: 12
      };
    } else {
      r['font'] = {
        color: {
          argb: 'FF'+this.defaultTextColor
        },
        size: 12
      };
    }

    if (t.classList.contains(this.indClass) || t.classList.contains(this.indClass2) || t.classList.contains(this.indClass3)) {
      r['alignment'] = {
        indent: 2
      };
    }


    if (t.classList.contains(this.backgroundClass2) || t.classList.contains(this.backgroundClass2b)) {
      r['fill'] = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF'+this.backgroundColor2
        }
      };
      r['font'] = {
        bold: true,
        color: {
          argb: 'FF'+this.headColor
        }
      };
    } else if (t.classList.contains(this.backgroundClass3) || t.classList.contains(this.backgroundClass3b)) {
      r['fill'] = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF'+this.backgroundColor3
        },
      };
      r['font'] = {
        bold: true,
        color: {
          argb: 'FF'+this.headColor
        }
      };
    }

    if(t.classList.contains(this.highlightBorderTopClass) && t.classList.contains(this.highlightBorderRightClass)){
      r['border'] = {
        top: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        },
        right: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        }
      };
    } else if(t.classList.contains(this.borderClass) && t.classList.contains(this.highlightBorderRightClass)){
      r['border'] = {
        right: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        },
        bottom: {
          style: this.borderStyle,
          color: {
            argb: 'FF'+this.borderColor
          }
        }
      };
    } else if(t.classList.contains(this.borderClass) && t.classList.contains(this.highlightBorderTopClass)){
      r['border'] = {
        top: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        },
        bottom: {
          style: this.borderStyle,
          color: {
            argb: 'FF'+this.borderColor
          }
        }
      };
    } else if (t.classList.contains(this.borderClass)) {
      r['border'] = {
        bottom: {
          style: this.borderStyle,
          color: {
            argb: 'FF'+this.borderColor
          }
        }
      };
    } else if (t.classList.contains(this.borderClass5)) {
      r['border'] = {
        top: {
          style: this.borderStyle2,
          color: {
            argb: 'FF'+this.borderColor2
          }
        }
      };
    } else if (t.classList.contains(this.borderClass2) || t.classList.contains(this.borderClass3) || t.classList.contains(this.borderClass6)) {
      r['border'] = {
        bottom: {
          style: this.borderStyle2,
          color: {
            argb: 'FF'+this.borderColor2
          }
        }
      };
    } else if (t.classList.contains(this.borderClass4)) {
      r['border'] = {
        top: {
          style: this.borderStyle2,
          color: {
            argb: 'FF'+this.borderColor2
          }
        }
      };
    } else if(t.classList.contains(this.highlightBorderTopClass)){
      r['border'] = {
        top: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        }
      };
    } else if(t.classList.contains(this.highlightBorderRightClass)){
      r['border'] = {
        right: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        }
      };
    } else if(t.classList.contains(this.highlightBorderBottomClass)){
      r['border'] = {
        bottom: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        }
      };
    } else if(t.classList.contains(this.highlightBorderLeftClass)){
      r['border'] = {
        left: {
          style: this.highlightBorderStyle,
          color: {
            argb: 'FF'+this.highlightBorderColor
          }
        }
      };
    }
    else {
      r['border'] = {
      };
    }

    return r;
  }

  parseFootnote(table, worksheet) {
    let footnotes;

    if ( this.externalFootnotes ) {
      let parentNode = table.parentNode; // get ns-outer-table-wrapper
      let nextSibling = parentNode.nextElementSibling;

      if ( Helper.hasClass(nextSibling, 'ns-footnote-container') && !!nextSibling.querySelectorAll('li[class*=' + this.footnoteClass + ']').length ) {
        footnotes = [...nextSibling.querySelectorAll('li[class*=' + this.footnoteClass + ']')].map(footnote => footnote.innerHTML);
      }
    }

    if(!!table.querySelectorAll('p[class*=' + this.footnoteClass + ']').length) {
      footnotes = [...table.querySelectorAll('p[class*=' + this.footnoteClass + ']')].map(footnote => footnote.innerHTML);
    } else if(!!table.nextElementSibling) {
      if([...table.nextElementSibling.classList].join().indexOf(this.footnoteClass) != -1) {
        footnotes = table.nextSibling.innerHTML.split('<br>');
      }
    }

    if(!!footnotes){
      let row;

      worksheet.addRow([]);
      footnotes.forEach((footnote, id) => {
        worksheet.addRow([footnote.replace('&nbsp;', ' ').replace(/(<([^>]+)>)/gi, "")]);
        row = worksheet.lastRow;
        worksheet.mergeCells('A'+row.getCell(1)._row.number, 'AZ'+row.getCell(1)._row.number);

        row.getCell('A').font = {
          size: 9,
          color: {
            argb: 'FF'+this.boldColor
          }
        };

        if ( id == footnotes.length - 1 ) {
          row.getCell('A').border = {
            bottom: {
              style: this.borderStyle2,
              color: {
                argb: 'FF'+this.borderColor2
              }
            }
          };
        }
      });
    }
  }

  mergeCells(worksheet, mergeStrings){
    // worksheet.mergeCells('A3:Z3');
    mergeStrings.forEach(cells => {
      worksheet.mergeCells(cells);
    });
  }

  async saveFile(fileName, workbook) {
    const xls64 = await workbook.xlsx.writeBuffer({
      base64: true
    })
    saveAs(
      new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      fileName
    )
  }

  getDownloadName(table){
    let dl = table.previousElementSibling;
    if(!!dl){
      if(!!dl.classList.contains('ns-table-download')){
        return dl.innerText;
      } else if(!!dl.previousElementSibling) {
        if(!!dl.previousElementSibling.classList.contains('ns-table-download')) {
          return dl.previousElementSibling.innerText;
        }
      }
    }
  }

  getFileTitle(table) {
    if(this.getDownloadName(table)){
      return this.getDownloadName(table);
    };
    return table.dataset.xFileTitle;
  }

  getTitle(table) {
    if(this.getDownloadName(table)){
      return this.getDownloadName(table);
    };
    return table.dataset.xTitle;
  }

  getTableTitle(table) {
    let tableTitleElem;
    if(table.previousElementSibling.classList.contains('ns-table-title')){
      tableTitleElem = table.previousElementSibling;
    } else if(table.previousElementSibling.previousElementSibling.classList.contains('ns-table-title')) {
      tableTitleElem = table.previousElementSibling.previousElementSibling;
    }
    return tableTitleElem.innerText;
  }

  parseCell(tableData, counter){

    let cell = document.createElement('td');
    let innerHtml = tableData.innerHTML.replace(/(\&shy;|­|&#173;)/gi, "");
    cell.innerHTML = innerHtml;

    if(cell.querySelector(".line_bold_blue") && cell.querySelector(".light") && this.cellInStylesBold == null && this.cellInStylesLight == null){
      let cellLineBold = cell.querySelector(".line_bold_blue");
      let cellLight = cell.querySelector(".light");
      this.cellInStylesBold = cellLineBold.innerHTML;
      this.cellInStylesLight = cellLight.innerHTML;
    } else if(cell.querySelector(".light") && this.cellInStylesLight == null) {
      let cellLight = cell.querySelector(".light");
      this.cellInStylesLight = cellLight.innerHTML;
    }

    let sup = cell.querySelector('.superscript');
    let supContent = '';

    if(sup && sup.innerText){
      supContent = this.superScript.split("")[1] ?
      this.superScript.split("")[0].trim() + this.correctNumber(sup.innerText) + this.superScript.split("")[1].trim() :
      this.correctNumber(sup.innerText) + this.superScript.split("")[0].trim();
      sup.parentNode.removeChild(sup);
    }

    if(tableData.classList.contains('ns-border-left')){
     this.cellStyles[counter] = {left: {style:'double', color: {argb:'FF00FF00'}}};
    }

    if(counter == 1){
      return this.correctNote(cell.innerText.trim() + ' ' + supContent);
    } else if(tableData.querySelector('.note__link')){
      return this.correctNote(cell.innerText.trim() + ' ' + supContent);
    }  else if(cell.innerText.split('.').length > 2){
      return cell.innerText.trim();
    } else{
      return this.correct(cell.innerText.trim());
    }
  }

  countLines(text) {
    return text.split(/\r\n|\r|\n/).length;
  }

  correct(text) {
    let r = "";
    if(document.documentElement.lang === "de-DE"){
      r = text.replace(/\./g, '').replace(/\,/g, '.').replace(/–/g, '-').replace(/(\&shy;|­|&#173;)/gi, "");
    } else{
      r = text.replace(/\,/g, '').replace(/\–/g, '-').replace(/(\&shy;|­|&#173;)/gi, "");
    }
    return r.trim();
  }

  correctNote(text) {
    return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-');
  }

  correctNumber(number) {
    return number.replace(/[^0-9,]/g, '');
  }

  getLetter(number){
    const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ"];
    return letters[number-1];
  }

  getEnvironement(){
    const body = document.querySelector('body');
    return !!body.classList.contains('wp-production') ? 'production' : 'stage';
  }

}
export default XDownloader;
